// PHCDashboardReducer.js
import { PHCDashboardConstants } from "./PHCDashboardConstants";

const initialState = {
  tags: [],
  activePortfolioId: null,
  currentView: "graph",
  justUploadedPortfolioId: null,
  nonExistentPortfolios: [],
  isFromOneMoney: false,

  fileUploadAttempts: 0,
  loading: false,
  error: null,
  completedPortfolioId: null,
};

const PHCDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case PHCDashboardConstants.FETCH_PORTFOLIO_REQUEST:
      return { ...state, loading: true, error: null };

    case PHCDashboardConstants.FETCH_PORTFOLIO_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload.list,
        fileUploadAttempts: action.payload.fileUploadAttempts,
      };

    case PHCDashboardConstants.FETCH_PORTFOLIO_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case PHCDashboardConstants.ADD_PORTFOLIO:
      return { ...state, list: [...state.list, action.payload] };

    case PHCDashboardConstants.SET_COMPLETED_PORTFOLIO:
      return { ...state, completedPortfolioId: action.payload };

    case PHCDashboardConstants.UPDATE_PORTFOLIO:
      return {
        ...state,
        list: state.list.map((item) =>
          item.portfolioId === action.payload.portfolioId
            ? { ...item, ...action.payload }
            : item,
        ),
      };

    case PHCDashboardConstants.SET_TAGS:
      return { ...state, tags: action.payload };

    case PHCDashboardConstants.SET_ACTIVE_PORTFOLIO:
      return { ...state, activePortfolioId: action.payload };

    case PHCDashboardConstants.SET_CURRENT_VIEW:
      return { ...state, currentView: action.payload };

    case PHCDashboardConstants.SET_JUST_UPLOADED_PORTFOLIO:
      return { ...state, justUploadedPortfolioId: action.payload };

    case PHCDashboardConstants.ADD_NON_EXISTENT_PORTFOLIO:
      return {
        ...state,
        nonExistentPortfolios: [...state.nonExistentPortfolios, action.payload],
      };

    case PHCDashboardConstants.SET_FROM_ONE_MONEY:
      return { ...state, isFromOneMoney: action.payload };

    default:
      return state;
  }
};

export default PHCDashboardReducer;
